import React from 'react';
import TextField, {TextFieldProps} from '@material-ui/core/TextField';
import {makeStyles} from '@material-ui/core/styles';

const LoginTextField = (props: TextFieldProps) => {
  const css = useStyles();
  const className = css.input + ' ' + (props.className ?? '');
  return <TextField {...props} variant="outlined" className={className} />;
};

const useStyles = makeStyles(() => ({
  input: {
    '& .MuiInputBase-input': {
      fontSize: 20,
      height: 40,
    },
  },
}));

export default LoginTextField;
